import React from 'react';

import Banner, {BannerProps, MessageLevel} from 'ui-library/banners/Banner';

export type WarningBannerProps = Pick<BannerProps, 'children'>;

/**
 * Renders a full width warning banner with a message.
 * @deprecated Please use client/ui-library/banners/InlineBanner instead
 */
export default function WarningBanner(props: WarningBannerProps): JSX.Element {
  return <Banner {...props} level={MessageLevel.WARNING} />;
}
